import Signup from './Signup';
import InternalSignup from './InternalSignup';

export default Signup;
export {
  InternalSignup,
};
